import { Card, Stack, Typography, useTheme } from '@mui/material';
import { FC } from 'react';

import Avatar from './Avatar.svg';
import Williams from './Williams.svg';

const CostSavingsTestimonialCard: FC = () => {
  const { spacing } = useTheme();
  return (
    <Card sx={{ backgroundColor: 'white', borderRadius: spacing(1), padding: spacing(2) }}>
      <Stack direction="row" justifyContent="center" alignItems="flex-start" gap={spacing(1)}>
        <img alt="Avatar" src={Avatar} />
        <Stack gap={spacing(1)} justifyContent="flex-start" alignItems="flex-start">
          <Typography variant="body1">
            &quot;We&apos;re saving anywhere from $50K to $100K switching from another fuel card to Coast.&quot;
          </Typography>
          <Typography variant="body2">Sam Frank, Owner of Four Twelve Roofing</Typography>
        </Stack>
      </Stack>
    </Card>
  );
};

const TimeSavingsTestimonialCard: FC = () => {
  const { spacing } = useTheme();
  return (
    <Card sx={{ backgroundColor: 'white', borderRadius: spacing(1), padding: spacing(2) }}>
      <Stack gap={spacing(2)} justifyContent="flex-start" alignItems="flex-start">
        <img alt="Avatar" src={Williams} />
        <Typography variant="body1">
          &quot;It&apos;s the ease, efficiency, and peace of mind. Coast gives us a safer, more controlled way to manage
          everything in one place.&quot;
        </Typography>
        <Stack spacing={0}>
          <Typography variant="body2">Lewis Williams</Typography>
          <Typography variant="body2">Owner of Mike Williams (Plumbing & HVAC)</Typography>
        </Stack>
      </Stack>
    </Card>
  );
};

export { CostSavingsTestimonialCard, TimeSavingsTestimonialCard };
